/* Coupon Block v7.4 – robust quantity rebinding + plus/minus support */
(function () {
  const SELECTORS = {
    block: '[data-coupon-block-id]',
    productForms: ['form[action*="/cart/add"]', '[id^="product-form-"] form', 'product-form form'],
    hiddenVariantInput: 'input[name="id"]',
    priceWrappers: ['[data-price-wrapper]', '.price', '[data-product-price]', '[data-product-info]'],
    variantContainers: ['variant-selects', 'variant-radios', '[data-product-variants]', '[data-section-type="product"]'],
    optionControls: [
      'select[name^="options"]',
      'input[name^="options"][type="radio"]',
      '[data-option-index] select',
      '[data-option-index] input[type="radio"]'
    ],
    variantJsonScripts: [
      'variant-selects script[type="application/json"]',
      'variant-radios script[type="application/json"]',
      'script#ProductJson-product-template',
      'script[type="application/json"][data-product]',
      'script[type="application/json"][data-product-json]'
    ],
    quantityInputs: [
      'input[name="quantity"]',
      '[data-quantity-input]',
      '.quantity__input',
      'quantity-input input[type="number"]'
    ],
    quantityButtonsPlus: [
      'button[name="plus"]',
      '[data-quantity-increment]',
      '.quantity__button--plus',
      '.quantity__button[aria-label*="increase"]'
    ],
    quantityButtonsMinus: [
      'button[name="minus"]',
      '[data-quantity-decrement]',
      '.quantity__button--minus',
      '.quantity__button[aria-label*="decrease"]'
    ],
    // 如果主题显示数量到某个元素文本，可加入选择器辅助读取
    quantityTextDisplays: ['[data-quantity-value]']
  };

  const qs = (s) => document.querySelector(s);
  const qsa = (s) => Array.from(document.querySelectorAll(s));
  const first = (arr) => arr.find(Boolean) || null;
  const findAll = (selectors) => selectors.flatMap(sel => Array.from(document.querySelectorAll(sel)));

  function formatMoney(cents, formatStr) {
    const placeholder = /\{\{\s*(\w+)\s*\}\}/;
    const fmt = formatStr || '{{ amount }}';
    function withDelims(n, p = 2, thou = ',', dec = '.') {
      if (isNaN(n) || n == null) return '0';
      const s = (n / 100).toFixed(p);
      const [d, c] = s.split('.');
      const dollars = d.replace(/(\d)(?=(\d{3})+(?!\d))/g, `$1${thou}`);
      return c ? dollars + dec + c : dollars;
    }
    const val = withDelims(cents, 2);
    return fmt.replace(placeholder, val);
  }

  // 读取当前数量：先读输入框，其次读显示文本，默认 1
  function getQuantity() {
    const inputs = findAll(SELECTORS.quantityInputs);
    for (const input of inputs) {
      const v = parseInt(input.value, 10);
      if (!isNaN(v) && v > 0) return v;
    }
    const displays = findAll(SELECTORS.quantityTextDisplays);
    for (const el of displays) {
      const v = parseInt((el.textContent || '').trim(), 10);
      if (!isNaN(v) && v > 0) return v;
    }
    return 1;
  }

  class CouponBlock {
    constructor(el) {
      this.el = el;
      this.copyButton = el.querySelector('[data-copy-button]');
      this.couponCodeSpan = el.querySelector('[data-coupon-code]');
      this.saveAmountSpan = el.querySelector('[data-save-amount]');
      this.couponTitle = el.querySelector('.coupon-title');
      this.moneyFormat = window.Shopify?.currency?.format || '{{ amount }}';
      this.currencyCode = window.Shopify?.currency?.active || '';

      if (this.copyButton) {
        this.copyButton.addEventListener('click', () => {
          const txt = (this.couponCodeSpan?.textContent || '').trim();
          navigator.clipboard.writeText(txt).then(() => {
            this.copyButton.classList.add('copied');
            setTimeout(() => this.copyButton.classList.remove('copied'), 1200);
          }).catch(() => {});
        });
      }
      // --- 新增：初始化倒计时 ---
      if (this.el.dataset.showCountdown === 'true') {
        this.initializeCountdown();
      }
      // -----------------------------
    }

    // --- 新增：倒计时逻辑 ---
    initializeCountdown() {
      const deadlineStr = this.el.dataset.countdownDeadline;
      if (!deadlineStr) return;

      // 在日期字符串后附加 PDT，以确保浏览器正确解析时区
      const deadline = new Date(`${deadlineStr} PDT`);
      if (isNaN(deadline.getTime())) {
        console.error("Coupon Block: Invalid deadline format.", deadlineStr);
        return;
      }
      
      const daysEl = this.el.querySelector('[data-countdown-days]');
      const hoursEl = this.el.querySelector('[data-countdown-hours]');
      const minutesEl = this.el.querySelector('[data-countdown-minutes]');
      const secondsEl = this.el.querySelector('[data-countdown-seconds]');
      const timerEl = this.el.querySelector('.coupon-countdown-timer');

      if (!daysEl || !hoursEl || !minutesEl || !secondsEl || !timerEl) return;

      const updateTimer = () => {
        const now = new Date();
        const diff = deadline.getTime() - now.getTime();

        if (diff <= 0) {
          clearInterval(this.countdownInterval);
          timerEl.textContent = 'Offer has expired.';
          return;
        }

        const days = Math.floor(diff / (1000 * 60 * 60 * 24));
        const hours = Math.floor((diff % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
        const minutes = Math.floor((diff % (1000 * 60 * 60)) / (1000 * 60));
        const seconds = Math.floor((diff % (1000 * 60)) / 1000);
        
        // 使用 padStart 补零，确保始终是两位数
        daysEl.textContent = String(days).padStart(2, '0');
        hoursEl.textContent = String(hours).padStart(2, '0');
        minutesEl.textContent = String(minutes).padStart(2, '0');
        secondsEl.textContent = String(seconds).padStart(2, '0');
      };

      this.countdownInterval = setInterval(updateTimer, 1000);
      updateTimer(); // 立即执行一次，避免初始延迟
    }

    updateSavings(variant) {
      if (!variant) {
        if (this.couponTitle) this.couponTitle.style.display = 'none';
        return;
      }
      const price = variant.price;
      const compare = variant.compare_at_price;
      const quantity = getQuantity();

      if (compare && compare > price) {
        const savings = (compare - price*0.9) * quantity;
        let formatted = formatMoney(savings, this.moneyFormat);
        if (this.currencyCode && !formatted.includes(this.currencyCode)) {
          formatted += ` ${this.currencyCode}`;
        }
        if (this.saveAmountSpan) this.saveAmountSpan.textContent = formatted;
        if (this.couponTitle) this.couponTitle.style.display = 'block';
      } else {
        if (this.couponTitle) this.couponTitle.style.display = 'none';
      }
    }
  }

  // -------- 变体解析 --------
  let PRODUCT_VARIANTS = null;
  function loadVariantJson() {
    if (PRODUCT_VARIANTS) return PRODUCT_VARIANTS;
    for (const sel of SELECTORS.variantJsonScripts) {
      const s = qs(sel);
      if (s?.textContent) {
        try {
          const data = JSON.parse(s.textContent.trim());
          if (Array.isArray(data)) { PRODUCT_VARIANTS = data; return PRODUCT_VARIANTS; }
          if (Array.isArray(data?.variants)) { PRODUCT_VARIANTS = data.variants; return PRODUCT_VARIANTS; }
        } catch (_) {}
      }
    }
    const p = window?.meta?.product || window?.ShopifyAnalytics?.meta?.product;
    if (p?.variants) { PRODUCT_VARIANTS = p.variants; return PRODUCT_VARIANTS; }
    return null;
  }

  function getVariantById(id) {
    const list = loadVariantJson();
    if (!list || !id) return null;
    return list.find(v => String(v.id) === String(id)) || null;
  }

  function getVariantFromUrl() {
    const params = new URLSearchParams(location.search);
    const id = params.get('variant');
    return id ? getVariantById(id) : null;
  }

  function getVariantIdFromAnyForm() {
    const forms = [...findAll(SELECTORS.productForms), ...qsa('form')];
    for (const f of forms) {
      const idEl = f.querySelector('input[name="id"]');
      const id = idEl?.value || (new FormData(f).get('id') || '');
      if (id) return id;
    }
    return null;
  }

  function getVariantFromOptions() {
    const controls = findAll(SELECTORS.optionControls);
    if (!controls.length) return null;
    const values = [];
    controls.forEach(ctrl => {
      if (ctrl.tagName === 'SELECT') {
        values.push(ctrl.value);
      } else if (ctrl.type === 'radio') {
        const name = ctrl.name;
        const checked = document.querySelector(`input[name="${CSS.escape(name)}"]:checked`);
        if (checked) values.push(checked.value);
      }
    });
    if (!values.length) return null;
    const variants = loadVariantJson();
    if (!variants) return null;
    return variants.find(v =>
      (!v.option1 || v.option1 === values[0]) &&
      (!v.option2 || v.option2 === values[1]) &&
      (!v.option3 || v.option3 === values[2])
    ) || null;
  }

  let lastVariantFromEvent = null;
  function getCurrentVariant() {
    if (lastVariantFromEvent) return lastVariantFromEvent;
    const id = getVariantIdFromAnyForm();
    if (id) {
      const v = getVariantById(id);
      if (v) return v;
    }
    const viaUrl = getVariantFromUrl();
    if (viaUrl) return viaUrl;
    const viaOptions = getVariantFromOptions();
    if (viaOptions) return viaOptions;
    return null;
  }

  // -------- 数量监听（可重绑）--------
  const boundQtyInputs = new WeakSet();
  const boundQtyButtons = new WeakSet();

  function bindQtyListeners(inst) {
    // 绑定输入框
    const qtyInputs = findAll(SELECTORS.quantityInputs);
    qtyInputs.forEach(input => {
      if (boundQtyInputs.has(input)) return;
      // 输入/变更
      input.addEventListener('input', () => inst.updateSavings(getCurrentVariant()), { passive: true });
      input.addEventListener('change', () => inst.updateSavings(getCurrentVariant()), { passive: true });
      // 属性变化（某些主题直接 setAttribute 不触发事件）
      const obs = new MutationObserver(() => inst.updateSavings(getCurrentVariant()));
      obs.observe(input, { attributes: true, attributeFilter: ['value'] });
      boundQtyInputs.add(input);
    });

    // 绑定 plus / minus 按钮
    const plusButtons = findAll(SELECTORS.quantityButtonsPlus);
    const minusButtons = findAll(SELECTORS.quantityButtonsMinus);
    [...plusButtons, ...minusButtons].forEach(btn => {
      if (boundQtyButtons.has(btn)) return;
      btn.addEventListener('click', () => {
        // 给主题逻辑一点时间更新数量
        setTimeout(() => inst.updateSavings(getCurrentVariant()), 60);
      });
      boundQtyButtons.add(btn);
    });
  }

  // —— 观察全局，数量节点被替换时重绑（关键修复点）——
  function observeQuantityMount(inst) {
    const observer = new MutationObserver(() => {
      bindQtyListeners(inst);
    });
    observer.observe(document.body, { childList: true, subtree: true });
  }

  // -------- 主流程 --------
  function setup() {
    const block = qs(SELECTORS.block);
    if (!block) return;
    const inst = new CouponBlock(block);

    loadVariantJson();
    inst.updateSavings(getCurrentVariant());

    // 主题事件：优先拿 e.detail.variant
    document.addEventListener('variant:change', (e) => {
      const v = e?.detail?.variant || null;
      lastVariantFromEvent = v;
      bindQtyListeners(inst);              // 变体切换可能替换数量控件 => 重绑
      setTimeout(() => inst.updateSavings(getCurrentVariant()), 50);
    }, true);

    // 价格区域变化
    const priceWrapper = first(SELECTORS.priceWrappers.map(qs).filter(Boolean));
    if (priceWrapper) {
      const o = new MutationObserver(() => {
        bindQtyListeners(inst);            // 有些主题同时替换数量控件 => 重绑
        setTimeout(() => inst.updateSavings(getCurrentVariant()), 100);
      });
      o.observe(priceWrapper, { childList: true, subtree: true, characterData: true });
    }

    // 任意交互触发（变体选择 / 表单）
    const onInteract = () => {
      bindQtyListeners(inst);              // 交互后也重绑一次，防止丢监听
      setTimeout(() => inst.updateSavings(getCurrentVariant()), 80);
    };
    qsa('form').forEach(f => {
      f.addEventListener('change', onInteract, true);
      f.addEventListener('click', onInteract, true);
    });
    findAll(SELECTORS.variantContainers).forEach(vc => {
      vc.addEventListener('change', onInteract, true);
      vc.addEventListener('click', onInteract, true);
    });

    // 隐藏 id 变化
    qsa('input[name="id"]').forEach(input => {
      const obs = new MutationObserver(onInteract);
      obs.observe(input, { attributes: true, attributeFilter: ['value'] });
    });

    // URL ?variant= 变化
    (function hookHistory() {
      const _ps = history.pushState, _rs = history.replaceState;
      const fire = () => onInteract();
      history.pushState = function () { const r = _ps.apply(this, arguments); fire(); return r; };
      history.replaceState = function () { const r = _rs.apply(this, arguments); fire(); return r; };
      window.addEventListener('popstate', fire);
    })();

    // 交互后短脉冲兜底
    function pulse() {
      let i = 0;
      const t = setInterval(() => {
        inst.updateSavings(getCurrentVariant());
        if (++i >= 6) clearInterval(t);
      }, 200);
    }
    document.addEventListener('click', (e) => {
      if (e.target.closest('fieldset') || e.target.matches('select') || e.target.matches('input[type=radio]')) {
        pulse();
      }
    }, true);

    // 观察全局以捕捉数量控件替换，并立即重绑（核心修复）
    observeQuantityMount(inst);
    // 首次绑定
    bindQtyListeners(inst);

    // Shopify 编辑器
    document.addEventListener('shopify:section:load', () => {
      lastVariantFromEvent = null;
      PRODUCT_VARIANTS = null;
      loadVariantJson();
      bindQtyListeners(inst);
      inst.updateSavings(getCurrentVariant());
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', setup);
  } else {
    setup();
  }
})();
